import classes from "../../css/Layout.module.scss";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import mam from "../../assets/mamManual.svg";
import viewer from "../../assets/mamViewerManual.svg";

const Layout = (props) => {

    const { i18n } = useTranslation();
    const cookies = new Cookies();

    const changeLang = (e) =>{
        i18n.changeLanguage(e);
        cookies.set("lang", e, { path: "/" });
    }

    return (
        <div className={classes.content}>
            <div className={classes.languageSelector}>
                <select
                    className={classes.langInput}
                    id="language"
                    name="language"
                    onChange={(e) => changeLang(e.target.value)}
                >
                    <option value="en"> English</option>
                </select>
            </div>
            <div className={classes.manuals}>
                <a href={window.Manuals.mamviewer_manual_url} target="_blank">
                    <button className={classes.buttonManual}>
                        <img
                        
                            className={classes.viewerIcon}
                            src={viewer}
                            alt="reload Icon"
                            htmlFor="reload-icon" 
                        />
                    </button>
                </a>                
            </div>
            {props.children}
            
        </div>
    );
 
};

export default Layout;
